<script>
/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: process.env.NODE_ENV == "production" ? "history" : "hash",
	routes,
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve({ x: 0, y: 0 });
			}, 500);
		});
	}
});

router.beforeEach((to, from, next) => {
	store.dispatch("triggerLoading", true);

	if (to.name == "grading") {
		store.dispatch("triggerHideFooter", true);
	} else {
		store.dispatch("triggerHideFooter", false);
	}

	if (to.name == "home-ar") {
		store.dispatch("setArabic", true);
	} else {
		store.dispatch("setArabic", false);
	}

	if (store.state.user) {
		next();
	} else if (to.name == "home" || to.name == "home-ar") {
		next();
	} else {
		var count = 0;
		var interval = setInterval(() => {
			if (store.state.user) {
				clearInterval(interval);
				next();
			}

			count++;
			console.log(count);
			if (count == 10) {
				clearInterval(interval);
				next(false);
				router.push("/");
			}
		}, 500);
	}
});

router.afterEach((to, from) => {
	// ...
});

router.beforeResolve((to, from, next) => {
	next();
});

export default router;
</script>